<template>
  <div class="lg:flex mt-4">
    <div class="w-3/4 md:w-1/2 mx-auto flex content-center">
      <!-- <img src="@/assets/images/onboarding/subs.svg"/> -->
      <img src="@/assets/images/onboarding/pricing_year.svg"/>
      <!-- <img src="@/assets/images/onboarding/pricing_christmas.svg"/> -->
    </div>

    <div class="flex flex-wrap lg:w-1/2 content-center lg:mx-8 justify-center">

      <h5 class="mb-2 mx-2 w-full font-bold text-purple text-center">{{miniheadline}}</h5>

      <div v-if="!showIamNotInterested">

        <h1 class="lg:text-5xl text-4xl mx-2 w-full font-bold text-dark text-center">{{claim1}}
        </h1>

        <h1 class="lg:text-5xl text-4xl mb-6 mx-2 w-full font-bold text-dark text-center">{{claim2}}
      </h1>

      <div class="w-full flex justify-center">

        <OldCard v-if="priceVariantGrouped == 'old'"/>
        <BigMacCard v-if="priceVariantGrouped == 'bigMac'"/>
        <StudentCard v-if="priceVariantGrouped == 'student'"/>
        <YearlyCard v-if="priceVariantGrouped == 'yearly'"/>
      </div>
      <div class="mt-2 w-full flex justify-center items-baseline">
        <p class="mt-2 font-bold text-center">
          {{cta1}}
        </p>
      </div>

    <div v-if="bigMacPriceVariant" class="mt-2 w-full flex justify-center items-baseline">
          <div class="mx-2">

            <form ref="bigMacForm" method="POST" action="/create-big-mac">
              <input type="hidden" name="customer_email" :value="userEmail"/>
              <input type="hidden" name="cancel_url" :value="cancelUrl"/>
              <input type="hidden" name="success_url" :value="successUrl"/>
              <input type="hidden" name="client_reference_id" :value="clientReferenceId"/>
              <input type="hidden" name="price" :value="bigMacPrice"/>
            </form>

            <div class="flex flex-col items-center">
                <vs-button color="#5222D0" @click="submitBigMac"> <span class="line-through mr-1 text-grey"></span>
                  <span class="font-semibold">I choose self-development</span><span class="track-go-to-stripe track-go-to-stripe-monthly text-xs"></span></vs-button>
                <span class="text-xs font-italic">
                  monthly subscription, cancel anytime
                </span>
              </div>
          </div>

      </div>

    <div v-if="priceVariantGrouped == 'yearly'" class="mt-2 w-full flex justify-center items-baseline">
          <div class="mx-2">
            <stripe-checkout
              ref="checkoutRefYearlyOnly"
              mode="subscription"
              :pk="publishableKey"
              :line-items="lineItemsYearly"
              :success-url="successUrl"
              :cancel-url="cancelUrl"
              @loading="v => loading = v"
              :customerEmail="userEmail"
              :clientReferenceId="clientReferenceId"
            />
            <div class="flex flex-col items-center">
                <vs-button color="#5222D0" @click="submitYearlyOnly"> <span class="line-through mr-1 text-grey"></span>
                  <span class="line-through  text-grey">49€</span>
                  <span class="font-semibold">
                  39€<span class="text-xs">/yr</span> </span><span class="track-go-to-stripe track-go-to-stripe-monthly text-xs"></span></vs-button>
                <span class="text-xs font-italic">
                  cancel anytime
                </span>
              </div>
          </div>

      </div>

    <div v-if="priceVariantGrouped == 'old'" class="mt-2 w-full flex justify-center items-baseline">
          <div class="mx-2">
            <stripe-checkout
              ref="checkoutRefYearly"
              mode="subscription"
              :pk="publishableKey"
              :line-items="lineItemsYearly"
              :success-url="successUrl"
              :cancel-url="cancelUrl"
              @loading="v => loading = v"
              :customerEmail="userEmail"
              :clientReferenceId="clientReferenceId"
            />
            <div class="flex flex-col items-center">
              <vs-button color="#5222D0" @click="submitYearly"> <span class="line-through mr-1 text-grey">€{{priceYearlyByDay * 2}}</span>
                <span class="font-semibold">€{{priceYearlyByDay}}<span class="text-xs">/day</span></span><span class="track-go-to-stripe track-go-to-stripe-yearly text-xs"></span></vs-button>
              <span class="text-xs font-italic">
                paid yearly
              </span>
            </div>
          </div>
          <div class="mx-2">
            <stripe-checkout
              ref="checkoutRefMonthly"
              mode="subscription"
              :pk="publishableKey"
              :line-items="lineItemsMonthly"
              :success-url="successUrlMonthly"
              :cancel-url="cancelUrl"
              @loading="v => loading = v"
              :customerEmail="userEmail"
              :clientReferenceId="clientReferenceId"
            />
             <div class="flex flex-col items-center">
              <vs-button color="#5222D0" @click="submitMonthly"><span class="line-through mr-1 text-grey">€{{priceMonthlyByDay * 2}}</span><span class="font-semibold">€{{priceMonthlyByDay}}<span class="text-xs">/day</span> </span><span class="track-go-to-stripe track-go-to-stripe-monthly text-xs"></span></vs-button>
                <span class="text-xs font-italic">
                  paid monthly
                </span>
              </div>
          </div>
      </div>

      <div v-if="priceVariantGrouped == 'student'" class="mt-2 w-full flex justify-center items-baseline">
          <div class="mx-2">
            <stripe-checkout
              ref="checkoutStudent"
              mode="subscription"
              :pk="publishableKey"
              :line-items="lineItemsMonthly"
              :success-url="successUrlMonthly"
              :cancel-url="cancelUrl"
              @loading="v => loading = v"
              :customerEmail="userEmail"
              :clientReferenceId="clientReferenceId"
            />
             <div class="flex flex-col items-center">
              <vs-button color="#5222D0" @click="submitStudent"><span class="line-through mr-1 text-grey">€{{priceMonthlyByDay * 2}}</span><span class="font-semibold">€{{priceMonthlyByDay}}<span class="text-xs">/day</span></span></span><span class="track-go-to-stripe track-go-to-stripe-monthly text-xs"></span></vs-button>
                <span class="text-xs font-italic">
                  paid monthly
                </span>
              </div>
          </div>
      </div>

        <div v-if="priceVariantGrouped == 'old'" class="w-full mt-2 text-center mt-4 text-xl text-dark font-bold">
          🔥&nbspSAVE 50% - <span class=" ml-1">improvee.io Anniversary💥</span>
        </div>




        <div class="text-center mt-4">
          <a class=" text-sm cursor-pointer hover:underline" @click="showIamNotInterested = !showIamNotInterested">I am not interested</a>
        </div>


      </div>
      <div v-if="showIamNotInterested" class="text-center text-black">
        <div class="mb-4 text-lg">
          <span class="font-bold">
            We understand that paying for Improvee.io may not be the right decision for you at this time.
          </span> But why?
        </div>

          <Checkbox class="text-small mb-1" :namespace="timestamp" :key="`${timestamp}-cost`" initValue="cost" title="The cost is too high" v-model="iAmNotInterested" />
          <Checkbox class="text-small mb-1" :namespace="timestamp" :key="`${timestamp}-notSureItWillWork`" initValue="notSureItWillWork" title="I'm not sure if it will work for me" v-model="iAmNotInterested" />
          <Checkbox class="text-small mb-1" :namespace="timestamp" :key="`${timestamp}-notUserFriendly`" initValue="notUserFriendly" title="The app is not user-friendly" v-model="iAmNotInterested" />
          <Checkbox class="text-small mb-1" :namespace="timestamp" :key="`${timestamp}-dontHaveTime`" initValue="dontHaveTime" title="I don't have time to use it regularly" v-model="iAmNotInterested" />
          <Checkbox class="text-small mb-1" :namespace="timestamp" :key="`${timestamp}-lackTrust`" initValue="lackTrust" title="I lack trust in the company or product" v-model="iAmNotInterested" />
          <Checkbox class="text-small mb-1" :namespace="timestamp" :key="`${timestamp}-haventEnoughTime`" initValue="haventEnoughTime" title="I haven't had enough time to evaluate it" v-model="iAmNotInterested" />
          <Checkbox class="text-small mb-1" :namespace="timestamp" :key="`${timestamp}-dontWantProvideCard`" initValue="dontWantProvideCard" title="I don't want to provide credit card information" v-model="iAmNotInterested" />

          <div class="flex justify-center">
            <vs-input
                v-model="iAmNotInterestedText"
                placeholder="other reason"
                name="title"
                class="w-1/2"
                autocomplete="off"
                ref="titleInput"
                size="small"
                @blur="saveIamNotInterested"
            />
          </div>

        <div class="mt-8 text-lg mb-4">
          We wish you all the best in your endeavors.❤️
        </div>

        <vs-button size="small" class="mt-2 text-sm text-center cursor-pointer hover:underline" @click="showIamNotInterested = !showIamNotInterested">go back</vs-button>

      </div>
    </div>

  </div>
</template>

<script>
import { usersCollection } from '@/firebase/data'
import { currentUserId } from '@/firebase/firebase'
import trackAnalytics from '@/helpers/trackAnalytics'
import { StripeCheckout } from '@vue-stripe/vue-stripe'
import _ from 'lodash'
import OldCard from './OldCard'
import BigMacCard from './BigMacCard'
import StudentCard from './StudentCard'
import YearlyCard from './YearlyCard'

export default {
  props: {
  },
  components: {
    StripeCheckout,
    OldCard,
    BigMacCard,
    StudentCard,
    YearlyCard
  },
  data () {
    return {
      timestamp: null,
      iAmNotInterested: [],
      iAmNotInterestedText: null,
      texts: {
        miniheadline: {
          bigMac: 'subscription',
          student: 'subscription',
          old: 'subscription',
          yearly: 'subscription',
        },
        claim1: {
          bigMac: 'BigMac 🍔 or',
          student: 'Student-friendly pricing',
          old: 'achieve success',
          yearly: 'Make your',
        },
        claim2: {
          bigMac: 'self-development?',
          student: '',
          old: 'and fulfillment',
          yearly: 'future self proud',
        },
        cta1: {
          bigMac: 'Make the right choice, it\'s up to you',
          student: 'Make the right choice, it\'s up to you',
          old: 'find the best plan for you',
          yearly: 'Your choice, your future',
        },
      },
      showIamNotInterested: false,
      show: false,
      closeHidden: false,
      unsubscribeForChangesHandler: null,
      showExtendTrial: false,
      whatAreYouMissing: null,
      loading: false,
      showDiscountInput: false,
      discountCode: '',
      production: true,
      productionPk: 'pk_live_51KL99FFeMcXJ0CrNLToDG7SXdKVp9RHGYpNYsdRDwhztkcU8Px0x3bN4b611YUC4hi0yJuY0QJ3jUFKXCPEYzWBZ00DWSyOJ6t',
      testPk: 'pk_test_51KL99FFeMcXJ0CrNFAGV34lfXPxnSVR4Ew4EAIcCH7zkvIerJ4rBhG9jxmgRpbY7lhPuQYBWha6d79uRfPO5wo31004IYS49kG',
      successUrl: `${window.location.origin}/thankyouyearly?session_id={CHECKOUT_SESSION_ID}`,
      successUrlMonthly: `${window.location.origin}/thankyoumonthly?session_id={CHECKOUT_SESSION_ID}`,
      cancelUrl: `${window.location.origin}/planner`,
      defaultPriceProduction: {
        priceMonthly: 3.99,
        priceYearly: 39,
        yearlyPriceRef: 'price_1KT9DjFeMcXJ0CrN8BaSM77v',
        monthlyPriceRef:'price_1LG0pBFeMcXJ0CrNn7r7cmip',
      },
      defaultPriceTest: {
        priceMonthly: 3.99,
        priceYearly: 39,
        yearlyPriceRef: 'price_1Mvxl5FeMcXJ0CrNBajJ66cy',
        monthlyPriceRef:'price_1MvxkmFeMcXJ0CrN49TEz0Em',
      },
      pricesVariants: {
        "3_9": {
          priceMonthly: 3.99,
          priceYearly: 39,
          yearlyPriceRef: 'price_1KT9DjFeMcXJ0CrN8BaSM77v',
          monthlyPriceRef:'price_1LG0pBFeMcXJ0CrNn7r7cmip',
        },
        "2_9": {
          priceMonthly: 2.99,
          priceYearly: 29,
          yearlyPriceRef: 'price_1KqIGeFeMcXJ0CrNmW385x6r',
          monthlyPriceRef:'price_1KfqTNFeMcXJ0CrN6mV2XjS4',
        },
        "1_9": {
          priceMonthly: 1.99,
          priceYearly: 19,
          yearlyPriceRef: 'price_1LeEAcFeMcXJ0CrNMY5l2tlp',
          monthlyPriceRef:'price_1LeEAEFeMcXJ0CrNyw9obdaD',
        },
        "bigMac": {
          monthlyPriceRef: 'price_1MppRBFeMcXJ0CrNEdJGOPwW',
        },
        "student": {
          priceMonthly: 0.99,
          priceYearly: 9.9,
          yearlyPriceRef: 'price_1MgmSsFeMcXJ0CrNiTVO0eqE',
          monthlyPriceRef:'price_1MgmRUFeMcXJ0CrNSAsWg7pn',
        },
        "yearly": {
          priceYearly: 39,
          yearlyPriceRef: 'price_1KT9DjFeMcXJ0CrN8BaSM77v',
        },

      },
      discountDataProduction: [
        {
          name: 'student',
          priceMonthly: 1.49,
          priceYearly: 14.9,
          yearlyPriceRef: 'price_1LD9ZEFeMcXJ0CrN7NvSfHxd',
          monthlyPriceRef:'price_1LD9YIFeMcXJ0CrNEoA863nU',
          codes: ['LEKJKR', 'AWDHAK', 'QXTKZA', 'RPUSYI', 'BCMNVF', 'BARGXZ', 'KWYCIK', 'QCVBTT', 'OPHHBJ', 'QKOISV']
        },
        {
          name: 'friends_hesitation',
          priceMonthly: 2.99,
          priceYearly: 29.9,
          discountPercent: 25,
          yearlyPriceRef: 'price_1KqIGeFeMcXJ0CrNmW385x6r',
          monthlyPriceRef:'price_1KfqTNFeMcXJ0CrN6mV2XjS4',
          codes: ['DCUNVQ']
        }
      ],
      discountDataTest: [
        {
          name: 'student',
          priceMonthly: 1.49,
          priceYearly: 14.9,
          yearlyPriceRef: 'price_1LD9S4FeMcXJ0CrNRuUiR3Wh',
          monthlyPriceRef:'price_1LD9RDFeMcXJ0CrNQtF2Tu4s',
          codes: ['LEKJKR', 'AWDHAK', 'QXTKZA', 'RPUSYI', 'BCMNVF', 'BARGXZ', 'KWYCIK', 'QCVBTT', 'OPHHBJ', 'QKOISV']
        },
        {
          name: 'friends_hesitation',
          priceMonthly: 2.99,
          priceYearly: 29.9,
          discountPercent: 25,
          yearlyPriceRef: 'price_1LGKc1FeMcXJ0CrNwqAG3LAw',
          monthlyPriceRef:'price_1KfqPxFeMcXJ0CrNeP7jEWbx',
          codes: ['DCUNVQ']
        }
      ],
    }
  },
  watch: {
    iAmNotInterested: {
      immediate: false,
      handler (iAmNotInterested) {
        this.saveIamNotInterested()
      }
    },
  },
  computed: {
    miniheadline () {
      if (this.$store.getters.hasMembershipExpired) {
        return 'your trial has expired ⌛'
      } else {
        return this.texts.miniheadline[this.priceVariantGrouped]
      }
    },
    claim1 () {
      return this.texts.claim1[this.priceVariantGrouped]
    },
    claim2 () {
      return this.texts.claim2[this.priceVariantGrouped]
    },
    cta1 () {
      return this.texts.cta1[this.priceVariantGrouped]
    },
    cta2 () {
      return this.texts.cta2[this.priceVariantGrouped]
    },
    bigMacPrice () {
      return 'price_1M3e3lFeMcXJ0CrNanQk7y8W'
    },
   defaultPrice () {
      if (this.production) {
        return this.pricesVariants[this.priceVariant]
      } else {
        return this.defaultPriceTest
      }
   },
   discountData () {
      if (this.production) {
        return this.discountDataProduction
      } else {
        return this.discountDataTest
      }
    },
    priceVariant () {
      return this.$store.getters.priceVariant || "2_9"
    },
    priceVariantGrouped () {
      if (this.priceVariant == "bigMac") {
        return "bigMac"
      } else if ( this.priceVariant == "student") {
        return "student"
      } else if ( this.priceVariant == "yearly"){
        return "yearly"
      } else {
        return "old"
      }
    },
    bigMacPriceVariant () {
      return this.priceVariant == "bigMac"
    },
    publishableKey () {
      return (this.production ? this.productionPk : this.testPk)
    },
    priceYearlyByDay () {
      return this.computePriceForDay(this.defaultPrice.priceYearly)
    },
    priceMonthlyByDay () {
      return this.computePriceForDay(this.defaultPrice.priceMonthly * 12)
    },
    lineItemsYearlyDiscount () {
      if (this.discount) {
        return this.linePrice(this.discount.yearlyPriceRef)
      }
    },
    lineItemsMonthlyDiscount () {
      if (this.discount) {
        return this.linePrice(this.discount.monthlyPriceRef)
      }
    },
    lineItemsYearly () {
      return this.linePrice(this.defaultPrice.yearlyPriceRef)
    },
    lineItemsMonthly () {
      return this.linePrice(this.defaultPrice.monthlyPriceRef)
    },
    discountCodeInvalid () {
      if (this.discountCode) {
        return !this.discountCodeValid
      }
    },
    discountedPriceForDayYearly () {
      if (this.discount) {
        return this.computePriceForDay(this.discount.priceYearly)
      }
    },
    discountedPriceForDayMonthly () {
      if (this.discount) {
        return this.computePriceForDay(this.discount.priceMonthly * 12)
      }
    },
    discountPercent () {
      if (this.discount) {
        if (this.discount.discountPercent) {
          return this.discount.discountPercent
        } else {
          return _.round(100 * (1 - (this.discount.priceYearly / this.defaultPrice.priceYearly)))
        }
      }
    },
    discount () {
      return this.findDiscountByCode(this.discountCode)
    },
    discountCodeValid () {
      return !!this.discount
    },
    clientReferenceId () {
      const savedRewardful = this.$store.getters.rewardful
      const cookieRewardful = window.Rewardful && window.Rewardful.referral

      return  savedRewardful || cookieRewardful || ('checkout_'+(new Date).getTime())
    },
    validateForm () {
      return !this.errors.any()
    },
    userEmail () {
      return this.$store.getters.userEmail
    },
    userName () {
      return this.$store.getters.userFirstName
    },
  },
  mounted () {
    console.log('process.env.NODE_ENV', process.env.NODE_ENV)
    console.log('isDevEnv', this.isDevEnv())

    if (this.$route.query.productionmode) {
      this.production = true
    } else if (window.location.host === 'self-improvee-stage.herokuapp.com') {
      this.production = false
    } else if (process.env.NODE_ENV === 'production') {
      this.production = true
    } else {
      this.production = false
    }

    if (this.$store.getters.user.iAmNotInterested) {
      this.iAmNotInterested = this.$store.getters.user.iAmNotInterested.checked || []
      this.iAmNotInterestedText = this.$store.getters.user.iAmNotInterested.text
    }

    this.timestamp = Date.now() + Math.random()
  },
  methods: {
    doShowIAmNotInterested () {
      this.showIamNotInterested = true
      if (window.smartlook) {
        window.smartlook('track', 'showFirstExperience', { userId: this.$store.getters.userId })
      }
    },
    saveIamNotInterested () {
      console.log('saving saveIamNotInterested')
      this.$store.dispatch('UPDATE_USER_PARTIALLY', {
        iAmNotInterested: { text: this.iAmNotInterestedText, checked: this.iAmNotInterested } })
    },
    linePrice (priceRef) {
      return [
        {
          price: priceRef,
          quantity: 1,
        },
      ]
    },
    computePriceForDay (priceForYear) {
      return _.round(priceForYear / 365, 2)
    },
    findDiscountByCode (code) {
      if (code) {
        return _.find(this.discountData, (data) => {
          return _.includes(data.codes, code) ||
          _.includes(this.$store.getters.getDiscountCodesByName(data.name), code)
        })
      }
    },
    tellMeMore () {
      this.showMore = true
    },
    specialOffer () {
      window.open('https://docs.google.com/forms/d/e/1FAIpQLSemkdF_6J9Y0p6HIA2Bd8ALOTnz0x6Gslzge7r1cNmvUTWoZQ/viewform', '_blank')
    },
    submit () {
      // You will be redirected to Stripe's secure checkout page
      this.$vs.notify({
        title: '',
        text: 'You will be redirected to Stripe\'s secure checkout page',
        iconPack: 'feather',
        icon: 'icon-shopping-cart',
        color: '#000000',
        time: 4000,
      })

      this.$store.dispatch('ADDITIONAL_USER_INFO', { redirectedToCheckout: true })
      this.$store.dispatch('ADDITIONAL_USER_INFO', { discountCode: this.discountCode })
    },
    submitYearly () {
      this.submit()
      this.$refs.checkoutRefYearly.redirectToCheckout()
    },
    submitMonthly () {
      this.submit()
      this.$refs.checkoutRefMonthly.redirectToCheckout()
    },
    submitStudent () {
      this.submit()
      this.$refs.checkoutStudent.redirectToCheckout()
    },
    submitYearlyOnly () {
      this.submit()
      this.$refs.checkoutRefYearlyOnly.redirectToCheckout()
    },
    submitBigMac () {
      this.submit()
      this.$refs.bigMacForm.submit()
    },
    showExtendTrialToggle () {
      this.showExtendTrial = true
      trackAnalytics(this, 'membership', 'show_extend_trial')
    },
    subscribeForChanges () {
      this.unsubscribeForChangesHandler = usersCollection.doc(currentUserId()).onSnapshot((doc) => {
        // Updates on server
        if (!doc.metadata.hasPendingWrites) {
          const membership = doc.data().membership

          if (membership) {
            if (membership.tarif === 'regular') {
              this.$store.dispatch('FETCH_USER')

              this.$vs.notify({ title: 'Thank you for becoming a member!', text: 'We wish you a wonderful journey.', color: '#f2134c', iconPack: 'feather', icon: 'check_box', time: 1000000})
            }
          }
        }
      })
    },
    unsubscribeForChanges () {
      if (this.unsubscribeForChangesHandler) {
        this.unsubscribeForChangesHandler()
      }
    },
    // buyMembership () {
    //   trackAnalytics(this, 'membership', 'go_to_buy_us_coffee', null)
    //   window.open('https://www.buymeacoffee.com/selfimprovee', '_blank')
    // },
    extendTrial () {
      this.$validator.validateAll().then(async (result) => {
        console.log(result)
        if (!result) return
        const whatIsMissing = this.whatAreYouMissing
        this.$store.dispatch('EXTEND_TRIAL', { whatIsMissing })

        const t = `${this.userName}, thank you for your opinion. Your next (and last) 14-day trial has been activated. We wish you a wonderful journey.`

        this.$vs.notify({ title: 'Your trial was extended', text: t, color: '#f2134c', iconPack: 'feather', icon: 'check_box', time: 1000000})
        trackAnalytics(this, 'membership', 'extend_trial', null, this.$store.getters.daysFromRegistration)
      })
    }
  }
}
</script>

<style land="scss">

  .vs-popup--header {
    background: #ffffff
  }

  .vs-popup--title h3 {
    font-size: 1.5rem;
  }

  .trial-expired-popup__image {
    max-width: 385px;
  }

  .vs-popup--title {
    text-align: center;
    padding-top: 1rem;
    font-size: 2rem;
  }

  .vs-popup--title h3 {
    font-size: 2rem;
  }
</style>
